import { useContext, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import MainLayout from "../../../components/Sidebar/MainLayout";
import Dashboard from "../Dashboard/Dashboard";

// The public landing page lives on the marketing site, which links to /login and /create-account.
// Without it configured (local development) a visitor goes straight to the login page.
const MARKETING_URL = process.env.REACT_APP_MARKETING_URL;

const LeaveForMarketingSite = () => {
  useEffect(() => {
    window.location.replace(MARKETING_URL);
  }, []);
  return null;
};

const HomePage = () => {
  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <div className="flex justify-center mt-20">Loading...</div>;
  }

  if (user) {
    return (
      <MainLayout>
        <Dashboard />
      </MainLayout>
    );
  }

  return MARKETING_URL ? <LeaveForMarketingSite /> : <Navigate to="/login" replace />;
};

export default HomePage;
